import { render, staticRenderFns } from "./VObjectCard.vue?vue&type=template&id=5f8f7506&"
import script from "./VObjectCard.vue?vue&type=script&lang=js&"
export * from "./VObjectCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports